module.exports = __webpack_public_path__ + "img/prev_porte_disabled.40294ff5.png";